import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';
import { useController, useFormContext, useWatch } from 'react-hook-form';

import { MultiSelectSpaceTypeField } from 'src/common/SpaceTypeField';
import { transportTypeOptions } from 'src/features/add-trip/ServiceDetails/transportTypeOptions';

import { SchemeMetaFormValues } from './metaDefaultValues';

import type { HelperText } from '@bambi/component-library/src/components/forms/FormFieldHelperText/FormFieldHelperText';

const helperText: HelperText = {
  text: 'The space types the pricing scheme will apply to.',
  presentation: {
    type: 'tooltip' as const,
    iconPosition: 'input-right' as const,
  },
};

function SingleSpaceTypeField() {
  const { field, fieldState } = useController<
    SchemeMetaFormValues,
    'space_types'
  >({
    name: 'space_types',
    rules: { required: 'Space type is required' },
  });

  return (
    <DefaultFormFieldLayout
      label="Space Type *"
      inputId="space_types"
      error={fieldState.error?.message}
      helperText={helperText}
    >
      <Select
        value={field.value?.[0]}
        options={transportTypeOptions}
        testIdSuffix="space_types"
        onChange={(selected) =>
          field.onChange(selected?.value ? [selected.value] : [])
        }
        placeholder="Select a space type"
      />
    </DefaultFormFieldLayout>
  );
}

export function PricingWizardSpaceTypeSelection() {
  const { control } = useFormContext<SchemeMetaFormValues>();
  const spaceTypes = useWatch({ control, name: 'space_types' });
  const useMultiSelect = (spaceTypes?.length ?? 0) > 1;

  if (useMultiSelect) {
    return (
      <MultiSelectSpaceTypeField
        fieldPath="space_types"
        rules={{
          required: 'Must select at least 1 space type',
        }}
        helperText={helperText}
      />
    );
  }

  return <SingleSpaceTypeField />;
}
